import { ReactElement } from 'react';
import Modal from '@components/Modal';
import { Info } from '@phosphor-icons/react';
import Button from '@/components/DesignLibrary/Button';
import s from './PaymentPlanModificationNotAllowedModal.module.scss';

type Props = {
  onClose: () => void;
  description?: string;
};

const PaymentPlanModificationNotAllowedModal = ({ onClose, description }: Props): ReactElement => (
  <Modal hideBottomInset title="" onClose={onClose} >
    <div className={s.modificationNotAllowedModal}>
      <Info size={128} weight="fill" className={s.icon} />
      <p className={s.title}>This Payment Plan cannot be modified.</p>
      <p className={s.description}>{description || ''}</p>
      <Button size="lg" variant="primary" onClick={onClose} fullWidth>
        Close
      </Button>
    </div>
  </Modal>
);

export default PaymentPlanModificationNotAllowedModal;
